export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const maxChar = 50;
export const matrikelNrMaxChar = 8;
export const numRegex = /^\d+$/;
export const letterRegex = /^[a-zA-ZéäöüÄÖÜß -]+$/